import { render } from "./SpecialRequestView.vue?vue&type=template&id=7d357b80"
import script from "./SpecialRequestView.vue?vue&type=script&lang=js"
export * from "./SpecialRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__